"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var TooltipWrapper = /** @class */ (function (_super) {
    __extends(TooltipWrapper, _super);
    function TooltipWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipWrapper.prototype.findTrigger = function () {
        return this.find('.awsui-tooltip-trigger');
    };
    TooltipWrapper.prototype.findTooltipContent = function () {
        return this.find('.awsui-tooltip-text');
    };
    return TooltipWrapper;
}(dom_1.ComponentWrapper));
exports.default = TooltipWrapper;
//# sourceMappingURL=awsui-tooltip.js.map